"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNotificationMessageSchema = exports.NotificationMessageSchema = exports.NotificationFields = exports.NotificationTargetSchema = exports.castToNotificationType = exports.NotificationTypeSchema = exports.NotificationType = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
// We label these with n1
// n = notification (to distinguish from history or other events)
// 1 = version
var NotificationType;
(function (NotificationType) {
    // Accounts channels
    NotificationType["ACCOUNTS_USER_INVITED_TO_TEAM"] = "n1.accounts.user-invited-to-team";
    NotificationType["ACCOUNTS_USER_JOINED_TEAM"] = "n1.accounts.user-joined-team";
    NotificationType["ACCOUNTS_USER_LEFT_TEAM"] = "n1.accounts.user-left-team";
    // Apple Auth
    NotificationType["APPLE_AUTH_TOKEN_ERROR"] = "n1.apple-auth.auth-token-error";
    // Apple channels
    NotificationType["APPLE_CHANNELS_ASR_CHANNEL_CREATED"] = "n1.apple-channels.asr-channel-created";
    NotificationType["APPLE_CHANNELS_ASR_CHANNEL_UPDATED"] = "n1.apple-channels.asr-channel-updated";
    NotificationType["APPLE_CHANNELS_ASR_CHANNEL_DELETED"] = "n1.apple-channels.asr-channel-deleted";
    NotificationType["APPLE_CHANNELS_ASR_REGION_CREATED"] = "n1.apple-channels.asr-region-created";
    NotificationType["APPLE_CHANNELS_ASR_REGION_UPDATED"] = "n1.apple-channels.asr-region-updated";
    NotificationType["APPLE_CHANNELS_ASR_REGION_DELETED"] = "n1.apple-channels.asr-region-deleted";
    NotificationType["APPLE_CHANNELS_ASR_KEYWORD_CREATED"] = "n1.apple-channels.asr-keyword-created";
    NotificationType["APPLE_CHANNELS_ASR_KEYWORD_DELETED"] = "n1.apple-channels.asr-keyword-deleted";
    NotificationType["APPLE_CHANNELS_AST_CHANNEL_CREATED"] = "n1.apple-channels.ast-channel-created";
    NotificationType["APPLE_CHANNELS_AST_CHANNEL_UPDATED"] = "n1.apple-channels.ast-channel-updated";
    NotificationType["APPLE_CHANNELS_AST_CHANNEL_DELETED"] = "n1.apple-channels.ast-channel-deleted";
    NotificationType["APPLE_CHANNELS_AST_REGION_CREATED"] = "n1.apple-channels.ast-region-created";
    NotificationType["APPLE_CHANNELS_AST_REGION_UPDATED"] = "n1.apple-channels.ast-region-updated";
    NotificationType["APPLE_CHANNELS_AST_REGION_DELETED"] = "n1.apple-channels.ast-region-deleted";
    NotificationType["APPLE_CHANNELS_ATT_CHANNEL_CREATED"] = "n1.apple-channels.att-channel-created";
    NotificationType["APPLE_CHANNELS_ATT_CHANNEL_UPDATED"] = "n1.apple-channels.att-channel-updated";
    NotificationType["APPLE_CHANNELS_ATT_CHANNEL_DELETED"] = "n1.apple-channels.att-channel-deleted";
    NotificationType["APPLE_CHANNELS_ATT_REGION_CREATED"] = "n1.apple-channels.att-region-created";
    NotificationType["APPLE_CHANNELS_ATT_REGION_UPDATED"] = "n1.apple-channels.att-region-updated";
    NotificationType["APPLE_CHANNELS_ATT_REGION_DELETED"] = "n1.apple-channels.att-region-deleted";
    NotificationType["APPLE_CHANNELS_PPB_CHANNEL_CREATED"] = "n1.apple-channels.ppb-channel-created";
    NotificationType["APPLE_CHANNELS_PPB_CHANNEL_UPDATED"] = "n1.apple-channels.ppb-channel-updated";
    NotificationType["APPLE_CHANNELS_PPB_CHANNEL_DELETED"] = "n1.apple-channels.ppb-channel-deleted";
    NotificationType["APPLE_CHANNELS_PPB_REGION_CREATED"] = "n1.apple-channels.ppb-region-created";
    NotificationType["APPLE_CHANNELS_PPB_REGION_UPDATED"] = "n1.apple-channels.ppb-region-updated";
    NotificationType["APPLE_CHANNELS_PPB_REGION_DELETED"] = "n1.apple-channels.ppb-region-deleted";
    // Budgets
    NotificationType["BUDGETS_BUDGET_PLAN_EXHAUSTED"] = "n1.budgets.budget-plan-exhausted";
    NotificationType["BUDGETS_FUND_EXHAUSTED"] = "n1.budgets.fund-exhausted";
    NotificationType["BUDGETS_BUDGET_PLAN_STARTED"] = "n1.budgets.budget-plan-started";
    NotificationType["BUDGETS_BUDGET_PLAN_ENDED"] = "n1.budgets.budget-plan-ended";
    NotificationType["DAILY_BUDGET_REMAINING"] = "n1.budgets.daily-budget-remaining";
    NotificationType["DAILY_SPEND_COMPARE"] = "n1.budgets.daily-spend-compare";
    NotificationType["GENERAL_ERROR"] = "n1.general.error";
    // Payments
    NotificationType["PAYMENT_METHODS_EXPIRED"] = "n1.payments.payment-methods-expired";
    NotificationType["NO_PAYMENT_METHODS"] = "n1.payments.no-payment-methods";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
exports.NotificationTypeSchema = (0, core_1.StringUnion)([
    NotificationType.ACCOUNTS_USER_INVITED_TO_TEAM,
    NotificationType.ACCOUNTS_USER_JOINED_TEAM,
    NotificationType.ACCOUNTS_USER_LEFT_TEAM,
    NotificationType.APPLE_AUTH_TOKEN_ERROR,
    NotificationType.APPLE_CHANNELS_ASR_CHANNEL_CREATED,
    NotificationType.APPLE_CHANNELS_ASR_CHANNEL_UPDATED,
    NotificationType.APPLE_CHANNELS_ASR_CHANNEL_DELETED,
    NotificationType.APPLE_CHANNELS_ASR_KEYWORD_CREATED,
    NotificationType.APPLE_CHANNELS_ASR_KEYWORD_DELETED,
    NotificationType.APPLE_CHANNELS_ASR_REGION_CREATED,
    NotificationType.APPLE_CHANNELS_ASR_REGION_UPDATED,
    NotificationType.APPLE_CHANNELS_ASR_REGION_DELETED,
    NotificationType.APPLE_CHANNELS_AST_CHANNEL_CREATED,
    NotificationType.APPLE_CHANNELS_AST_CHANNEL_UPDATED,
    NotificationType.APPLE_CHANNELS_AST_CHANNEL_DELETED,
    NotificationType.APPLE_CHANNELS_AST_REGION_CREATED,
    NotificationType.APPLE_CHANNELS_AST_REGION_UPDATED,
    NotificationType.APPLE_CHANNELS_AST_REGION_DELETED,
    NotificationType.APPLE_CHANNELS_ATT_CHANNEL_CREATED,
    NotificationType.APPLE_CHANNELS_ATT_CHANNEL_UPDATED,
    NotificationType.APPLE_CHANNELS_ATT_CHANNEL_DELETED,
    NotificationType.APPLE_CHANNELS_ATT_REGION_CREATED,
    NotificationType.APPLE_CHANNELS_ATT_REGION_UPDATED,
    NotificationType.APPLE_CHANNELS_ATT_REGION_DELETED,
    NotificationType.APPLE_CHANNELS_PPB_CHANNEL_CREATED,
    NotificationType.APPLE_CHANNELS_PPB_CHANNEL_UPDATED,
    NotificationType.APPLE_CHANNELS_PPB_CHANNEL_DELETED,
    NotificationType.APPLE_CHANNELS_PPB_REGION_CREATED,
    NotificationType.APPLE_CHANNELS_PPB_REGION_UPDATED,
    NotificationType.APPLE_CHANNELS_PPB_REGION_DELETED,
    NotificationType.BUDGETS_BUDGET_PLAN_EXHAUSTED,
    NotificationType.BUDGETS_FUND_EXHAUSTED,
    NotificationType.BUDGETS_BUDGET_PLAN_STARTED,
    NotificationType.BUDGETS_BUDGET_PLAN_ENDED,
    NotificationType.DAILY_BUDGET_REMAINING,
    NotificationType.DAILY_SPEND_COMPARE,
    NotificationType.GENERAL_ERROR,
    NotificationType.PAYMENT_METHODS_EXPIRED,
    NotificationType.NO_PAYMENT_METHODS,
], {
    title: "Notification Message type",
    description: "Type of message",
});
exports.castToNotificationType = (0, cast_1.castToEnum)(NotificationType);
const NotificationTargettingFields = {
    // The destination of the message (one of)
    targetTeam: typebox_1.Type.Optional((0, core_1.StrictObject)({ teamId: core_1.IdSchema })),
    targetCampaign: typebox_1.Type.Optional((0, core_1.StrictObject)({ teamId: core_1.IdSchema, campaignId: core_1.IdSchema })),
    targetUser: typebox_1.Type.Optional((0, core_1.StrictObject)({ userId: core_1.IdSchema })),
    targetEmail: typebox_1.Type.Optional(core_1.EmailSchema),
};
exports.NotificationTargetSchema = (0, core_1.StrictObject)(NotificationTargettingFields);
exports.NotificationFields = {
    ...NotificationTargettingFields,
    // Payload for notifications (if generically known)
    timestamp: core_1.TimestampSchema,
    type: exports.NotificationTypeSchema,
    payload: typebox_1.Type.Unknown(),
};
exports.NotificationMessageSchema = (0, core_1.StrictObject)({
    ...exports.NotificationFields,
}, {
    title: "Notification Message",
    description: "Generic notification message",
});
// The generic ensures the type to payload compile accuracy.
// Without this, derived types accept all types for any payload.
function createNotificationMessageSchema(type, payloadSchema, options = {}) {
    return (0, core_1.StrictObject)({
        // The destination of the message (one of)
        ...NotificationTargettingFields,
        timestamp: core_1.TimestampSchema,
        type: typebox_1.Type.Literal(type),
        // Payload for notifications (if generically known)
        payload: payloadSchema,
    }, options);
}
exports.createNotificationMessageSchema = createNotificationMessageSchema;
